<div class="page-404" id="page-404">
    <div class="hero hero404" #hero>
        <h1 class="hero__title">Error</h1>
    </div>
    <div class="content404" id="content404">
        <h1>404</h1>
        <h3>Page not found</h3>
    </div>
    <!-- Should allow users to navigate back on mobile -->
    <app-bottom-navigation [showBackNav]="true" backRoute="home" backText="Home"></app-bottom-navigation> 
</div>
